module.exports = __webpack_public_path__ + "img/info-filled.188ac4c5.svg";